<template>
  <div>
    <loading
      :active.sync="loading_state.is_loading"
      :is-full-page="true"
      :can-cancel="true"
      :height="100"
      loader="spinner"
      color="#0095e9"
    ></loading>

    <side-bar :options="options" />
    <div class="m__l--300">
      <navbar />
    </div>

    <b-container fluid>
      <div class="p__l--300 position-in-sidebar p__t--30">
        <bread-crumb />
        <router-view></router-view>
      </div>
    </b-container>
  </div>
</template>

<script>
import Sidebar from '@/components/Sidebar';
import Breadcrumb from '@/components/Breadcrumb';
import Navbar from '@/components/Navbar';
import { mapState } from 'vuex';
export default {
  name: 'index-home',
  components: {
    'side-bar': Sidebar,
    'bread-crumb': Breadcrumb,
    navbar: Navbar
  },
  data() {
    return {
      user: JSON.parse(localStorage.getItem('user')),
      items: [
        {
          text: 'Admin',
          href: '#'
        },
        {
          text: 'Manage',
          href: '#'
        },
        {
          text: 'Library',
          active: true
        }
      ]
    };
  },
  computed: {
    ...mapState('StoreLoading', ['loading_state']),
    options() {
      return [
        // {
        //   path: '/home/dashboard',
        //   logo: 'fa fa-home',
        //   name: 'Dashboard',
        //   isShow: false,
        //   isAppear:
        //     this.user.role === 'ADMIN' || this.user.role === 'SUPERADMIN'
        //   //   children: [
        //   //     {
        //   //       path: '/home/dashboard/account',
        //   //       logo: 'fa fa-user',
        //   //       name: 'Account'
        //   //     },
        //   //     {
        //   //       path: '/home/dashboard/location',
        //   //       logo: 'fa fa-location-arrow',
        //   //       name: 'Location'
        //   //     }
        //   //   ]
        // },
        {
          path: '/home/account',
          logo: 'fa fa-user',
          name: 'Account',
          isAppear:
            this.user.role === 'ADMIN' || this.user.role === 'SUPERADMIN'
        },
        {
          path: '/home/location',
          logo: 'fa fa-location-arrow',
          name: 'Location',
          isAppear: this.user.role === 'SUPERADMIN'
        },
        {
          path: '/home/package',
          logo: 'fa fa-box',
          name: 'Package Travel',
          isShow: false,
          isAppear:
            this.user.role === 'ADMIN' || this.user.role === 'SUPERADMIN'
          //   children: [
          //     {
          //       path: '/home/package',
          //       logo: 'fa fa-times-circle',
          //       name: 'List'
          //     },
          //     {
          //       path: '',
          //       logo: 'fa fa-times-circle',
          //       name: 'Add'
          //     }
          //   ]
        },
        {
          path: '/home/attraction',
          logo: 'fa fa-magnet',
          name: 'Attraction',
          isShow: false,
          isAppear:
            this.user.role === 'ADMIN' || this.user.role === 'SUPERADMIN'
        }
      ];
    }
  },
  created() {
    const parameter = this.$route.path.split('/');
    parameter.splice(0, 1);
    this.items = parameter.map((data, index) => {
      return {
        text: data.charAt(0).toUpperCase() + data.substr(1).toLowerCase(),
        active: Number(index) === Number(parameter.length - 1),
        to: ''
      };
    });
  }
};
</script>

<style lang="scss">
.breadcrumb-section {
  a {
    color: #0095e9;
  }
  h3 {
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 37px;
  }
  .breadcrumb {
    padding-top: 7px;
    padding-left: 30px;
    background: unset;
  }
}
@media only screen and (max-width: 850px) {
  .position-in-sidebar.p__l--300 {
    padding-left: 80px !important;
  }
}
</style>
